(() => {
  'use strict';
  function initializeShopping() {
  if (window.dcShoppingInitialized) return;
  const bag = document.getElementById('dc-bag');
  const quick = document.getElementById('dc-quick');
  if (!bag || !quick || typeof bag.showModal !== 'function') return;
  window.dcShoppingInitialized = true;
  document.documentElement.classList.add('dc-shopping-ready');
  const root = window.Shopify?.routes?.root || '/';
  const bagContent = document.getElementById('dc-bag-content');
  const quickContent = document.getElementById('dc-quick-content');
  const bagStatus = document.getElementById('dc-bag-status');
  const quickStatus = document.getElementById('dc-quick-status');
  let busy = false, requestId = 0, previousOverflow = '', opener;
  const escapeHTML = value => String(value ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:window.Shopify?.currency?.active || 'USD'}).format(cents / 100);
  function status(element, message, error = false) {
    element.textContent = message;
    element.toggleAttribute('data-error', error);
  }
  function show(dialog, trigger) {
    if (!bag.open && !quick.open) {
      opener = trigger || document.activeElement;
      previousOverflow = document.body.style.overflow;
    }
    [bag, quick].forEach(other => { if (other !== dialog && other.open) other.close(); });
    if (!dialog.open) dialog.showModal();
    document.body.style.overflow = 'hidden';
  }
  [bag, quick].forEach(dialog => {
    dialog.addEventListener('close', () => {
      if (!bag.open && !quick.open) {
        document.body.style.overflow = previousOverflow;
        if (opener?.isConnected) opener.focus({preventScroll:true});
      }
    });
    dialog.addEventListener('click', event => {
      if (event.target.closest('[data-dc-close]')) dialog.close();
      else if (event.target === dialog) {
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      }
    });
  });
  async function jsonResponse(response) {
    const data = await response.json();
    if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : typeof data.message === 'string' ? data.message : 'Could not update your bag. Please try again.');
    return data;
  }
  function renderBag(html) {
    if (!html) throw new Error('Your bag could not be displayed. Open the full bag below.');
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const content = parsed.querySelector('[data-cart-panel-content]');
    if (!content) throw new Error('Your bag could not be displayed. Open the full bag below.');
    bagContent.replaceChildren(content);
    document.querySelectorAll('.cart-trigger span').forEach(el => { el.textContent = content.dataset.cartCount; });
  }
  function bagFailure(message) {
    status(bagStatus, message, true);
    if (!bagContent.querySelector('.dc-full-bag')) {
      const link = document.createElement('a');
      link.href = root + 'cart'; link.className = 'dc-all-products dc-full-bag'; link.textContent = 'Open full bag';
      bagContent.append(link);
    }
  }
  async function refreshBag() {
    const url = new URL(root + 'cart', location.origin);
    url.searchParams.set('section_id', 'cart-panel');
    const response = await fetch(url, {headers:{Accept:'text/html'},cache:'no-store'});
    if (!response.ok) throw new Error('Could not load your bag.');
    renderBag(await response.text());
  }
  async function updateAfterMutation(data) {
    if (data.sections?.['cart-panel']) renderBag(data.sections['cart-panel']);
    else await refreshBag();
  }
  document.addEventListener('click', async event => {
    if (event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const addButton = event.target.closest('.native-add, .mystery-crate__button, [data-quick-add]');
    if (addButton && !addButton.disabled) {
      const form = addButton.form || addButton.closest('form');
      if (form && form.reportValidity()) {
        event.preventDefault();
        event.stopImmediatePropagation();
        await handleAdd({target:form, submitter:addButton, preventDefault(){}, stopImmediatePropagation(){}});
      }
      return;
    }
    const cartLink = event.target.closest('a.cart-trigger');
    if (cartLink) {
      event.preventDefault(); if (busy) return;
      busy = true; show(bag, cartLink); status(bagStatus, 'Loading your bag…');
      try { await refreshBag(); status(bagStatus, ''); }
      catch (error) { bagFailure(error.message); }
      finally { busy = false; }
      return;
    }
    const quantityButton = event.target.closest('[data-cart-key]');
    if (quantityButton && bag.contains(quantityButton)) {
      if (busy) return;
      busy = true; bag.setAttribute('aria-busy', 'true'); status(bagStatus, 'Updating your bag…');
      let changed = false;
      const key = quantityButton.dataset.cartKey;
      const nextQuantity = quantityButton.dataset.quantity;
      try {
        const data = await jsonResponse(await fetch(root + 'cart/change.js', {
          method:'POST', headers:{'Content-Type':'application/json',Accept:'application/json'},
          body:JSON.stringify({id:key, quantity:Number(nextQuantity), sections:['cart-panel'], sections_url:root + 'cart'})
        }));
        changed = true; await updateAfterMutation(data); status(bagStatus, 'Bag updated.');
        const nextButton = [...bag.querySelectorAll('[data-cart-key]')].find(el => el.dataset.cartKey === key);
        (nextButton || bag.querySelector('[data-dc-close]')).focus({preventScroll:true});
      } catch (error) {
        bagFailure(changed ? 'Your bag was updated, but the display could not refresh. Open the full bag to check it.' : error.message);
      } finally { busy = false; bag.removeAttribute('aria-busy'); }
      return;
    }
    const quickButton = event.target.closest('[data-quick-product]');
    if (!quickButton) return;
    event.preventDefault();
    const currentRequest = ++requestId;
    show(quick, quickButton); quickContent.replaceChildren(); status(quickStatus, 'Loading options…');
    try {
      const productUrl = new URL(quickButton.dataset.quickProduct, location.origin);
      productUrl.pathname = productUrl.pathname.replace(/\/$/, '') + '.js';
      productUrl.search = '';
      const product = await jsonResponse(await fetch(productUrl, {headers:{Accept:'application/json'}}));
      if (currentRequest !== requestId) return;
      renderQuick(product, quickButton.dataset.quickProduct); status(quickStatus, '');
    } catch (error) {
      if (currentRequest !== requestId) return;
      status(quickStatus, 'Could not load options. You can open the product page instead.', true);
      const link = document.createElement('a'); link.href = quickButton.dataset.quickProduct;
      link.className = 'dc-quick-details'; link.textContent = 'View product'; quickContent.append(link);
    }
  }, true);
  function renderQuick(product, url) {
    const initial = product.variants.find(v => v.available) || product.variants[0];
    if (!initial) throw new Error('Product options unavailable.');
    const hasOptions = !(product.options.length === 1 && product.options[0].name === 'Title' && product.options[0].values.length === 1 && product.options[0].values[0] === 'Default Title');
    const image = initial.featured_image?.src || product.featured_image;
    quickContent.innerHTML = `${image ? `<img class="dc-quick-photo" src="${escapeHTML(image)}" alt="${escapeHTML(product.title)}">` : ''}
      <h3 class="dc-quick-name">${escapeHTML(product.title)}</h3><p class="dc-quick-price" data-quick-price></p>
      <form action="${escapeHTML(root)}cart/add" method="post" data-quick-form>
      <input type="hidden" name="id" value="${initial.id}"><input type="hidden" name="quantity" value="1">
      ${hasOptions ? product.options.map((option, index) => `<fieldset class="dc-options"><legend>${escapeHTML(option.name)}</legend><div class="dc-option-values">${option.values.map(value => `<label class="dc-option"><input type="radio" name="option-${index}" data-option-index="${index}" value="${escapeHTML(value)}" ${initial.options[index] === value ? 'checked' : ''}><span>${escapeHTML(value)}</span></label>`).join('')}</div></fieldset>`).join('') : ''}
      <p data-quick-availability role="status"></p><button type="submit" class="dc-primary" data-quick-add>Add to bag</button></form>
      <a class="dc-quick-details" href="${escapeHTML(url)}">Full details & sizing</a>`;
    const form = quickContent.querySelector('form');
    const button = form.querySelector('[data-quick-add]');
    function selectVariant() {
      const selected = hasOptions ? product.options.map((_, i) => form.querySelector(`[data-option-index="${i}"]:checked`)?.value) : initial.options;
      const variant = product.variants.find(v => v.options.every((value, i) => value === selected[i]));
      form.elements.id.value = variant?.id || '';
      button.disabled = !variant?.available;
      button.textContent = !variant ? 'Combination unavailable' : variant.available ? 'Add to bag' : 'Sold out';
      quickContent.querySelector('[data-quick-price]').textContent = variant ? money(variant.price) : 'Unavailable';
      form.querySelector('[data-quick-availability]').textContent = variant && !variant.available ? 'This option is currently sold out.' : '';
      const photo = quickContent.querySelector('.dc-quick-photo');
      if (photo && variant?.featured_image?.src) photo.src = variant.featured_image.src;
    }
    form.addEventListener('change', selectVariant); selectVariant();
  }
  async function handleAdd(event) {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const path = new URL(form.getAttribute('action') || form.action, location.origin).pathname;
    if (!/\/cart\/add(?:\.js)?\/?$/.test(path)) return;
    // Leave accelerated checkout to Shopify.
    if (event.submitter?.name === 'checkout' || event.submitter?.closest('.shopify-payment-button')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (busy) return;
    busy = true;
    const submit = event.submitter || form.querySelector('[type=submit]');
    const wasDisabled = submit?.disabled;
    if (submit) submit.disabled = true;
    const existingError = form.querySelector('.dc-shop-error'); if (existingError) existingError.remove();
    let added = false;
    try {
      const body = new FormData(form);
      body.set('sections','cart-panel'); body.set('sections_url', root + 'cart');
      const data = await jsonResponse(await fetch(root + 'cart/add.js', {method:'POST',headers:{Accept:'application/json'},body}));
      added = true; show(bag, form.closest('dialog') ? opener : submit); status(bagStatus, 'Added to your bag.');
      await updateAfterMutation(data);
    } catch (error) {
      if (added) bagFailure('Added to your bag, but the display could not refresh. Open the full bag to check it.');
      else {
        const message = document.createElement('p'); message.className = 'dc-shop-error'; message.setAttribute('role','alert');
        message.textContent = error.message || 'Could not confirm the add. Check your bag before trying again.'; form.append(message);
      }
    } finally { busy = false; if (submit) submit.disabled = wasDisabled; }
  }
  document.addEventListener('submit', handleAdd, true);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeShopping, {once:true});
  } else {
    initializeShopping();
  }
  document.addEventListener('shopify:section:load', initializeShopping);
})();
